import React from "react";
import { CardContent, Skeleton } from "@mui/material";

export const ArticleSkeleton: React.FC = () => (
  <div className="p-2 h-full">
    <div className="border rounded-lg flex flex-col h-full overflow-hidden bg-white p-4">
      <Skeleton variant="rectangular" className="w-full aspect-video" animation="wave" />
      <CardContent className="flex-grow">
        <Skeleton variant="text" width="90%" height={30} animation="wave" />
        <Skeleton variant="text" width="70%" animation="wave" />
        <Skeleton variant="text" width="40%" animation="wave" sx={{ mt: 2 }}/>
      </CardContent>
    </div>
  </div>
);